






















import { Component, Vue, Prop } from 'vue-property-decorator';
import DecoratedModal from '@/components/DecoratedModal.vue';
import MentorIcon from '@/components/parts/MentorIcon.vue';
import MentorInfo from '@/components/MentorInfo.vue';
import { Mentor } from '@/models/mentor';

@Component({
  components: {
    DecoratedModal,
    MentorIcon,
    MentorInfo
  }
})
export default class MentorModal extends Vue {
  @Prop()
  mentor?: Mentor | null;

  get getMentor() {
    return this.mentor;
  }

  onScroll(e: Event) {
    const icon = (this.$refs.icon as Vue).$el as HTMLDivElement;
    const mbody = e.target as HTMLDivElement;
    let top = 32 - mbody.scrollTop;
    const iwidth = icon.offsetWidth;
    top = top > iwidth / -2 ? top : iwidth / -2;
    icon.style.top = `${top}px`;
  }

  onClose(e: Event) {
    this.$emit('close', e);
  }
}
